import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { AuthTokenResponse, ErrorMessage, IndustryItem, LinkedBusinessAccount, Employee } from '@shared/models';
import { constants } from '@shared/constants';
import { AuthActions } from './auth.actions';

export interface AuthState {
  isLoading: boolean;
  loginError: ErrorMessage;
  isLoggedIn: boolean;
  businessAccount: LinkedBusinessAccount | null;
  tokenInfo: AuthTokenResponse | null;
  industries: IndustryItem[];
  user: Employee | null;
}

export const authInitialState: AuthState = {
  isLoading: false,
  loginError: null,
  isLoggedIn: false,
  businessAccount: null,
  tokenInfo: null,
  industries: [],
  user: null,
};

export const authFeature = createFeature({
  name: 'auth',
  reducer: createReducer(
    authInitialState,
    on(AuthActions.initialize, (state): AuthState => ({ ...state, isLoading: false })),
    on(AuthActions.authLogin, (state): AuthState => ({ ...state, isLoading: true })),
    on(
      AuthActions.authLoginSuccess,
      (state, { user, businessAccount }): AuthState => ({ ...state, user, businessAccount, isLoggedIn: true, isLoading: false }),
    ),
    on(AuthActions.authLoginFailure, (state, { error }): AuthState => ({ ...state, isLoading: false, loginError: error })),
    on(AuthActions.passwordExpired, (state): AuthState => ({ ...state, isLoading: false, loginError: null })),
    on(AuthActions.refreshTokenSuccess, (state, { tokenInfo }): AuthState => ({ ...state, tokenInfo })),
    on(AuthActions.authLogout, (): AuthState => authInitialState),
    on(AuthActions.resetLoginError, (state): AuthState => ({ ...state, loginError: null })),
    on(AuthActions.loadIndustriesSuccess, (state, { industries }): AuthState => ({ ...state, industries })),
  ),
  extraSelectors: ({ selectTokenInfo }) => ({
    selectTokenExpireInMilliseconds: createSelector(
      selectTokenInfo,
      (tokenInfo) => (tokenInfo?.expires_in ? parseInt(tokenInfo.expires_in, 10) : constants.DEFAULT_TOKEN_EXPIRE_IN_SECONDS) * 1000,
    ),
  }),
});
